import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/auth.context';
import Loader from '../loader/loader.component';

/**
 * ProtectedRoute wraps routes that require authentication.
 * - Shows a loader while auth state is being determined.
 * - Redirects unauthenticated users to the landing page.
 * - Renders children when the user is authenticated.
 *
 * @param {{ children: React.ReactNode }} props
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
